import { LangType } from 'common/constants';
import { patchRoute } from './patch-route';

export interface GetInitAuthUrlParams {
  authUrl: string;
  curPage: string;
  path: string;
  lang?: LangType;
  isKzDomain?: boolean;
}

export function getInitAuthUrl({ authUrl, curPage, path, isKzDomain, lang = 'ru' }: GetInitAuthUrlParams) {
  try {
    const { origin: authOrigin } = new URL(authUrl);
    const { origin } = new URL(curPage);

    path = patchRoute(path);

    if (isKzDomain) {
      return `${authOrigin}/?state=${origin}${path}&lang=${lang}`;
    }

    return `${authOrigin}/?state=${origin}${path}`;
  } catch (error) {
    return authUrl;
  }
}
